// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let WizardFormUtils = require("../../common/Form/WizardFormUtils.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");

function useFormControl(fieldUpdater, initialTouched, initialValue, valid) {
  let updateDraft = PropertyWizardFormRelay.useUpdateDraft();
  let update = value => updateDraft(current => {
    switch (fieldUpdater.TAG) {
      case "Draft" :
        return fieldUpdater._0(current, value);
      case "DraftProperty" :
        return {
          chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
          draftProperty: fieldUpdater._0(current.draftProperty, value),
          message: current.message,
          serverDraftId: current.serverDraftId,
          status: current.status,
          subject: current.subject,
          timeZone: current.timeZone
        };
      case "Showing" :
        let showingNum = fieldUpdater.showingNum;
        let showings = current.draftProperty.showings;
        let newrecord = {...current.draftProperty};
        let targetShowing = showings[showingNum];
        let tmp;
        if (targetShowing !== undefined) {
          let updatedShowing = fieldUpdater.updater(targetShowing, value);
          let updatedShowingsList = showings.slice();
          updatedShowingsList.splice(showingNum, 1, updatedShowing);
          tmp = updatedShowingsList;
        } else {
          tmp = showings;
        }
        newrecord.showings = tmp;
        return {
          chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
          draftProperty: newrecord,
          message: current.message,
          serverDraftId: current.serverDraftId,
          status: current.status,
          subject: current.subject,
          timeZone: current.timeZone
        };
    }
  });
  return WizardFormUtils.useFormControl(update, initialTouched, initialValue, valid);
}

exports.useFormControl = useFormControl;
/* WizardFormUtils Not a pure module */
